/**
 * Decode HTML entities (e.g. &amp; → &, &lt; → <) in a string.
 * Useful as a safety net when backend data may contain escaped HTML entities.
 */
export function decodeHtmlEntities(text: string | null | undefined): string {
  if (!text) return text as string;
  if (!text.includes('&')) return text;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}
